export const TableOptions = {
    noDataText: "No record found!"
}